import { createGetAsyncSlice } from '@sonar-software/xuder';
import { IssueVisibilityType } from '../../@types';
import { getIssues, GetIssuesRequestWithoutVisibility } from '../../api';

function handler(request: GetIssuesRequestWithoutVisibility) {
	return getIssues({
		...request,
		visibilityType: IssueVisibilityType.Archived
	});
}

export const issuesArchivedGetSlice = createGetAsyncSlice({
	name: 'issuesArchived',
	receive: true,
	request: true,
	requestHandler: handler,
	retainDataOnRequest: true
});
